export enum INPUT_MODES {
  DAY_HOUR_MINUTE = 'DAY_HOUR_MINUTE',
  HOUR_MINUTE = 'HOUR_MINUTE',
  WEEK_DAY_HOUR_MINUTE = 'WEEK_DAY_HOUR_MINUTE',
}
